"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidClientAppConfigProperty = isValidClientAppConfigProperty;
/**
 * Verifies that a property exists in client app config and has a valid value.
 */
function isValidClientAppConfigProperty(config, property) {
  if (property in config) {
    return config[property] != null && config[property] !== '';
  }
  return false;
}
//# sourceMappingURL=isValidClientAppConfigProperty.js.map